import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-entity-info-card',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './entity-info-card.component.html',
  styleUrls: ['./entity-info-card.component.scss'],
})
export class EntityInfoCardComponent {
  @Input() entity: any;
  @Input() entityType: 'joueur' | 'manager' | 'staff' | 'club' = 'joueur';

  getProfileImage(): string {
    return this.entity?.profile_link || '';
  }

  getEntityName(): string {
    if (this.entityType === 'club') {
      return this.entity?.club_name || '-';
    }
    return `${this.entity?.player_first_name || ''} ${this.entity?.player_last_name || ''} ${this.entity?.manager_first_name || ''} ${this.entity?.manager_last_name || ''}`.trim() || '-';
  }

  getStatusBadgeClass(): string {
    const status = this.entity?.relation_status_private;
    const statusMap: { [key: string]: string } = {
      LICNEW: 'bg-blue-500',
      LICNEA: 'bg-slate-500',
      LIRENE: 'bg-emerald-500',
      LIINAC: 'bg-amber-500',
      LIENCO: 'bg-orange-500',
      LIVALIN: 'bg-yellow-500',
      LITACCO: 'bg-cyan-500',
      LITACCN: 'bg-cyan-500',
      LICREJO: 'bg-red-500',
      LICREJN: 'bg-red-500',
    };
    return statusMap[status] || 'bg-stone-400';
  }

  getStatusLabel(): string {
    return this.entity?.relation_status_private_label || this.entity?.relation_status_private || '-';
  }

  getDOB(): string {
    if (!this.entity?.player_birthday && !this.entity?.manager_birthday) return '-';
    const dob = this.entity?.player_birthday || this.entity?.manager_birthday;
    return new Date(dob).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  getClubName(): string {
    if (this.entityType === 'club') {
      return '-';
    }
    return this.entity?.club_name || '-';
  }

  getPlayerCode(): string {
    return this.entity?.player_code || this.entity?.manager_code || '-';
  }
}
